import React, { Component } from "react";

import PropTypes from "prop-types";
import VisorBox from "./VisorBox";
import SubmitButton from "../score/SubmitButton";
import Score from "../score/Score";
import { Col, Tooltip, OverlayTrigger } from "react-bootstrap";
import VisorHeader from "./VisorHeader";
import { aspectRatio, changeFontBase } from "../../../common/common_tools";
import { sceneFontStyle } from "../../../common/course_font";
import ReactResizeDetector from "react-resize-detector";
import { isContainedView, isView } from "../../../common/utils";
import i18n from "i18next";
import ReactDOM from "react-dom";
import StageSeekZones from "../../chrome/StageSeekZones";
import { isEvalPlugin } from "../../../_editor/components/canvas/editor_shortcuts/assessmentMenuConfig";
import { sanitizeThemeHtml } from "../../../_editor/components/nav_bar/scene_theme_palette/sanitizeThemeHtml";
import { isRenderMode } from "../../utils/recorderMode";
import { driveSceneVideo, releaseSceneVideoSyncs } from "../../managers/sceneVideoDriver.es6";
import { boxStage } from "./boxStage";
import VisorBoxSlot from "./VisorBoxSlot";

let kapatGif =
  require("../../../dist/images/kapat.gif").default || require("../../../dist/images/kapat.gif");

export default class VisorCanvasSli extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: "100%",
      height: "100%",
      marginTop: 0,
      marginBottom: 0,
      fontBase: 14,
      flag: false,
      closeButton: false,
      disabledButton: false,
    };
    this.canvasRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentView !== nextProps.currentView || (!this.props.show && nextProps.show)) {
      this.setupDropzone();
    }
  }

  // DragDrop now uses dnd-kit inside DragDropVisor (draggable chips + droppable
  // slots), which owns its own drop handling. The old interactjs `.dropzoneq`
  // dropzone is gone — this is kept as a no-op so existing call sites stay safe.
  setupDropzone() {}

  render() {
    let titles = [];
    let itemSelected =
      this.props.navItems[this.props.currentView] ||
      this.props.containedViews[this.props.currentView];
    let isCV = !isView(this.props.currentView);
    let toolbar = this.props.viewToolbars[this.props.currentView];

    if (!toolbar) {
      toolbar = {
        background: "#ffffff",
        viewName: "Contained View",
        breadcrumb: "hidden",
      };
    }

    if (itemSelected !== 0 && !isCV) {
      let title = this.props.viewToolbars[this.props.currentView]?.viewName || "Page";
      titles.push(title);
      let parent = itemSelected.parent;
      while (parent !== 0) {
        let title2 = this.props.viewToolbars[parent]?.viewName || "Page";
        titles.push(title2);
        parent = this.props.navItems[parent].parent;
      }
      titles.reverse();
    }

    let maincontent = isCV
      ? document.getElementById("contained_maincontent")
      : document.getElementById("maincontent");
    let actualHeight;
    if (maincontent) {
      actualHeight = parseInt(maincontent.scrollHeight, 10);
      actualHeight =
        parseInt(maincontent.clientHeight, 10) < actualHeight ? actualHeight + "px" : "100%";
    }

    let overlayHeight = actualHeight ? actualHeight : "100%";
    let boxes = isCV
      ? this.props.containedViews[this.props.currentView].boxes || []
      : this.props.navItems[this.props.currentView].boxes || [];

    let thisView =
      this.props.viewsArray && this.props.viewsArray.length > 1
        ? i18n.t("messages.go_back_to") +
          (this.props.viewToolbars[this.props.viewsArray[this.props.viewsArray.length - 2]]
            ?.viewName || "Page")
        : i18n.t("messages.go_back");

    let backgroundIsUri = /data\:/.test(toolbar.background);
    let isColor = /rgb[a]?\(\d+\,\d+\,\d+(\,[\d\.]+)?\)/.test(toolbar.background);

    const tooltip = (
      <Tooltip id="tooltip" style={{ color: "white" }}>
        {thisView}
      </Tooltip>
    );
    let exercises = this.props.exercises[this.props.currentView];

    let animationType = "animation-zoom";
    let padding = this.props.fromPDF ? "0px" : "0px";

    let backgroundOpacity =
      1 -
      (toolbar && toolbar.backgroundOpacity != null ? Number(toolbar.backgroundOpacity) / 100 : 1);

    return (
      <Col
        ref={this.canvasRef}
        id={(isCV ? "containedCanvas_" : "canvas_") + this.props.currentView}
        md={12}
        xs={12}
        className={
          (isCV ? "containedCanvasClass " : "canvasClass ") +
          " canvasSliClass " +
          (isCV ? animationType : "") +
          (this.props.show ? "" : " hidden")
        }
        style={{
          width: "100%",
          padding,
          fontSize: this.state.fontBase ? this.state.fontBase + "px" : "14px",
        }}
      >
        <div
          id={(isCV ? "airlayer_cv_" : "airlayer_") + this.props.currentView}
          className={" slide_air airlayer"}
          style={{
            margin: "0 auto",
            visibility: this.props.showCanvas ? "visible" : "hidden",
            width: this.state.width,
            height: this.state.height,
            marginTop: this.state.marginTop,
            marginBottom: this.state.marginBottom,
          }}
        >
          <div
            id={isCV ? "contained_maincontent" : "maincontent"}
            className={"innercanvas sli"}
            style={{
              visibility: this.props.showCanvas ? "visible" : "hidden",
              background: isColor ? toolbar.background : "",
              backgroundImage: !isColor
                ? "linear-gradient(rgba(255,255,255," +
                  backgroundOpacity +
                  "), rgba(255,255,255," +
                  backgroundOpacity +
                  ")), url(" +
                  toolbar.background +
                  ")"
                : "",
              backgroundSize:
                toolbar && toolbar.background && toolbar.backgroundAttr === "fit"
                  ? "100% 100%"
                  : toolbar.backgroundAttr === "centered" || toolbar.backgroundAttr === "repeat"
                    ? toolbar.backgroundZoom !== undefined
                      ? toolbar.backgroundZoom + "%"
                      : "100%"
                    : "cover",
              backgroundRepeat:
                toolbar.backgroundAttr === "centered" || toolbar.backgroundAttr === "fit"
                  ? "no-repeat"
                  : "repeat",
              backgroundPosition:
                toolbar.backgroundAttr === "centered" ||
                toolbar.backgroundAttr === "full" ||
                toolbar.backgroundAttr === "fit"
                  ? "center center"
                  : "0% 0%",
              ...(toolbar && toolbar.themeCssVariables ? toolbar.themeCssVariables : {}),
              // VERIFY-LIVE: scene default font — boxes with inline CKEditor
              // font-family still override. Mirrors EditorCanvasSli; set by the
              // agent's setSceneFontAll mutation (batchSetSceneFont).
              ...sceneFontStyle(
                (toolbar && toolbar.fontFamily) || this.props.globalConfig?.fontFamily
              ),
            }}
          >
            {toolbar && toolbar.themeHtml && (
              <div
                className="theme-html-background pointer-events-none"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 0,
                }}
                dangerouslySetInnerHTML={{ __html: sanitizeThemeHtml(toolbar.themeHtml) }}
              />
            )}
            {/* Task 8 (visor-ui): double-tap seek zones. Mounted here (not at
                VisorApp level) so DOM order alone puts it above the stage
                background and below the boxes.map() below — see
                StageSeekZones.jsx's header comment for the full stacking
                trace. */}
            <StageSeekZones
              show={!!this.props.show}
              isMandatory={!!toolbar.isMandatory}
              elapsed={this.props.intervalDeltaTime || 0}
              onSeekTo={this.props.onSeekTo}
            />
            {isCV ? (
              <OverlayTrigger placement="bottom" overlay={tooltip}>
                <a
                  href="#"
                  className="btnOverBar cvBackButton"
                  style={{
                    pointerEvents: this.props.viewsArray.length > 1 ? "initial" : "none",
                    color: this.props.viewsArray.length > 1 ? "black" : "gray",
                  }}
                  onClick={(a) => {
                    // "#" under the Visor's <base href="/"> would leave the page.
                    a.preventDefault();
                    if (this.state.disabledButton == false) {
                      this.setState({ disabledButton: true });
                      setTimeout(() => {
                        this.setState({ disabledButton: false });
                      }, 3000);
                      this.canvasRef.current?.classList.add("exitCanvas");
                      setTimeout(
                        function () {
                          this.props.removeLastView();
                        }.bind(this),
                        500
                      );
                      a.stopPropagation();
                    }
                  }}
                >
                  {/* <i
                            style={{ display: this.state.closeButton ? "none" : "", backgroundColor: this.state.disabledButton ? "#f2f2f2" : "#eab700", fontSize: "24px" }}
                            className="material-icons">close</i> */}
                  <img
                    style={{
                      display: this.state.closeButton ? "none" : "",
                      width: "36px",
                      height: "36px",
                      border: "0px",
                    }}
                    src={kapatGif}
                  />
                </a>
              </OverlayTrigger>
            ) : (
              <span />
            )}
            {/* Built-in scene header removed: scenes never render an in-canvas
                title block in Visor either. If a title is needed it ships as an
                editable text element inside the scene. */}
            {boxes.length ? null : <div className="loader" />}
            {boxes.map((id) => {
              const rawBox = this.props.boxes[id];
              // Timeline visibility toggle (eye icon): hidden layers don't render
              // in the visor either — same rule as the editor preview.
              const timelineVisible =
                rawBox?.timeline?.visible !== undefined ? rawBox.timeline.visible : rawBox?.visible;
              if (timelineVisible === false) return null;
              const { textAnimation: _ta, ...box } = rawBox || {};
              // textAnimation'ı boxes prop'undan da sök — sadece boxAnimation ve boxExitAnimation kalacak
              const effectiveBoxes = rawBox?.textAnimation
                ? { ...this.props.boxes, [id]: box }
                : this.props.boxes;

              // Timeline bazlı görünürlük
              const currentFrame = this.props.visorFrameTime || 0;
              const pluginId = this.props.pluginToolbars?.[id]?.pluginId;
              this._videoEndCache = this._videoEndCache || {};
              const stageAt = (frame) =>
                boxStage({
                  id,
                  rawBox,
                  toolbar: this.props.pluginToolbars?.[id],
                  frame,
                  recorderMode: this.props.recorderMode,
                  videoEndCache: this._videoEndCache,
                });
              // Live boxes follow the committed frame themselves (VisorBoxSlot).
              let prewarm = false;
              if (this.props.recorderMode) {
                const stage = stageAt(currentFrame);
                if (stage === "off") return null;
                prewarm = stage === "prewarm";
              }

              // Export only; live videos are driven from the Visor frame loop.
              if (this.props.recorderMode && pluginId === "EnrichedPlayer") {
                this._recorderSyncs = this._recorderSyncs || {};
                driveSceneVideo(
                  {
                    sceneId: this.props.currentView,
                    frame: currentFrame,
                    playing:
                      this.props.visorPlaying &&
                      this.props.startButtonClicked &&
                      this.props.preloadCompleted &&
                      !this.props.videoBuffering &&
                      this.props.show,
                    recorderMode: true,
                    rate: this.props.playbackRate,
                    syncs: this._recorderSyncs,
                    boxes: this.props.boxes,
                    toolbars: this.props.pluginToolbars,
                    viewToolbars: this.props.viewToolbars,
                    exercises: IdealStudio.State.exercises,
                  },
                  id
                );
              }

              const renderBox = (prewarm) => (
                <VisorBox
                  key={id}
                  id={id}
                  prewarm={prewarm}
                  show={this.props.show}
                  intervalDeltaTime={this.props.intervalDeltaTime || 0}
                  visorFrameTime={this.props.visorFrameTime || 0}
                  playbackRate={this.props.playbackRate || 1}
                  exercises={exercises && exercises.exercises ? exercises.exercises[id] : undefined}
                  boxes={effectiveBoxes}
                  changeCurrentView={(element) => {
                    this.props.changeCurrentView(element);
                  }}
                  currentView={this.props.currentView}
                  fromScorm={this.props.fromScorm}
                  toolbars={this.props.pluginToolbars}
                  marks={this.props.marks}
                  setAnswer={this.props.setAnswer}
                  submitPage={this.props.submitPage}
                  tryAgainHandler={this.props.tryAgainHandler}
                  seeAnswerHandler={this.props.seeAnswerHandler}
                  onMarkClicked={this.props.onMarkClicked}
                  richElementsState={this.props.richElementsState}
                  nextView={() => {
                    this.props.nextView();
                  }}
                  checkAnswerForFreeResponse={this.props.checkAnswerForFreeResponse}
                  animationPause={this.props.animationPause}
                  animationPlay={this.props.animationPlay}
                  setSoundEnded={this.props.setSoundEnded}
                  setVideoEnded={this.props.setVideoEnded}
                  saveVideoProgress={this.props.saveVideoProgress}
                  getVideoProgress={this.props.getVideoProgress}
                  setOneClickEnded={this.props.setOneClickEnded}
                  isFirstSlide={this.props.isFirstSlide}
                  recorderMode={this.props.recorderMode}
                  onVideoCanPlayThrough={this.props.onVideoCanPlayThrough}
                  reportVideoStall={this.props.reportVideoStall}
                  visorPlaying={this.props.visorPlaying}
                  // Play intent and no media wait.
                  sceneAdvancing={this.props.visorPlaying !== false && !this.props.videoBuffering}
                  videoBuffering={this.props.videoBuffering}
                  preloadCompleted={this.props.preloadCompleted}
                  startButtonClicked={this.props.startButtonClicked}
                  setNextView={this.props.setNextView}
                  resetTriggered={this.props.resetTriggered}
                  visorSeekTo={this.props.visorSeekTo}
                  pauseSound={this.props.pauseSound}
                  nextPageCompleted={this.props.nextPageCompleted}
                  enabledRightButton={this.props.enabledRightButton}
                  setPlayingAudioUrlInContained={this.props.setPlayingAudioUrlInContained}
                  playingAudioInContained={this.props.playingAudioInContained}
                  themeId={
                    toolbar?.themeId ||
                    (this.props.globalConfig?.globalTheme?.applyToAll
                      ? this.props.globalConfig.globalTheme.themeId
                      : null) ||
                    null
                  }
                  paletteId={
                    toolbar?.paletteId ||
                    (this.props.globalConfig?.globalTheme?.applyToAll
                      ? this.props.globalConfig.globalTheme.paletteId
                      : null) ||
                    null
                  }
                  themeCssVariables={
                    toolbar?.themeCssVariables ||
                    (this.props.globalConfig?.globalTheme?.applyToAll
                      ? this.props.globalConfig.globalTheme.themeCssVariables
                      : null)
                  }
                />
              );
              if (this.props.recorderMode) return renderBox(prewarm);
              return (
                <VisorBoxSlot key={id} sceneId={this.props.currentView} stageAt={stageAt}>
                  {renderBox}
                </VisorBoxSlot>
              );
            })}

            {this.props.fromPDF || !exercises || !exercises.exercises ? null : (
              <div
                className={
                  "pageFooter" +
                  (!exercises ||
                  !exercises.exercises ||
                  Object.keys(exercises.exercises).length === 0
                    ? " hidden"
                    : "")
                }
              >
                <SubmitButton
                  onSubmit={() => {
                    this.props.submitPage(this.props.currentView);
                  }}
                  exercises={exercises}
                />
                {/*    <Score exercises={exercises}/>*/}
              </div>
            )}
          </div>
        </div>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={(e) => {
            if (!this.props.fromPDF) {
              let calculated = this.aspectRatio(this.props, this.state);
              this.setState({ fontBase: changeFontBase(calculated.width) });
            } else if (this.props.fromPDF) {
              this.setState({ fontBase: changeFontBase(this.props.expectedWidth) });
            }
          }}
        />
      </Col>
    );
  }
  componentDidUpdate(prevProps) {
    // aspectRatio(this.props.canvasRatio);
    if (this.props.show && !prevProps.show) {
      this.aspectRatioListener();
      if (
        this.props.viewToolbars[this.props.currentView].id.search("cv") === 0 &&
        this.props.viewToolbars[this.props.currentView].isMandatory &&
        this.props.viewToolbars[this.props.currentView].minTime &&
        this.props.currentView.search("cv") === 0
      ) {
        this.setState({ closeButton: true });
        setTimeout(() => {
          this.setState({ closeButton: false });
        }, this.props.viewToolbars[this.props.currentView].minTime + "000");
      }
    }
  }

  componentDidMount() {
    let isCV = !isView(this.props.currentView);
    let itemSel =
      this.props.navItems[this.props.currentView] ||
      this.props.containedViews[this.props.currentView];
    if (!this.props.fromPDF) {
      let calculated = this.aspectRatio(this.props, this.state);
      this.setState({ fontBase: changeFontBase(calculated.width) });
      window.addEventListener("resize", this.aspectRatioListener.bind(this));
    } else {
    }

    this._dropzoneInitialized = false;
    this._dropFlag = false;
    this.setupDropzone();
  }
  componentWillUnmount() {
    releaseSceneVideoSyncs(this._recorderSyncs);
    window.removeEventListener("resize", this.aspectRatioListener.bind(this));
  }

  aspectRatioListener() {
    let calculated = this.aspectRatio();
    this.setState({ fontBase: changeFontBase(calculated.width) });
  }

  aspectRatio(props = this.props, state = this.state) {
    let fromCV = !isView(props.currentView);
    let ar = props.canvasRatio;
    let itemSel = props.navItems[props.currentView] || props.containedViews[props.currentView];
    let customSize = itemSel.customSize;
    let fromVisor = true;

    // ponytail: question scenes get the full stage on portrait/narrow — the
    // letterbox otherwise crushes answer rows into a small middle band while
    // leaving large empty margins. Gated to eval scenes + width-limited stages
    // and hard-disabled during render/recorder mode so video export is byte-identical.
    let parentEl = this.canvasRef.current;
    let isQuestionScene = (itemSel.boxes || []).some((id) =>
      isEvalPlugin(props.pluginToolbars?.[id]?.pluginId)
    );
    if (
      !props.recorderMode &&
      !isRenderMode() &&
      isQuestionScene &&
      parentEl &&
      parentEl.offsetHeight > 0 &&
      parentEl.offsetWidth / parentEl.offsetHeight < (window.canvasRatio || props.canvasRatio)
    ) {
      let calculated = {
        width: parentEl.offsetWidth + "px",
        height: parentEl.offsetHeight + "px",
        marginTop: "0px",
        marginBottom: 0,
      };
      let { width, height, marginTop, marginBottom } = state;
      let current = { width, height, marginTop, marginBottom };
      if (JSON.stringify(calculated) !== JSON.stringify(current)) {
        this.setState({ ...calculated });
      }
      return calculated;
    }

    let calculated = aspectRatio(
      ar,
      (fromCV ? "airlayer_cv_" : "airlayer_") + props.currentView,
      (fromCV ? "containedCanvas_" : "canvas_") + props.currentView,
      customSize,
      fromVisor
    );
    let { width, height, marginTop, marginBottom } = state;
    let current = { width, height, marginTop, marginBottom };
    if (JSON.stringify(calculated) !== JSON.stringify(current)) {
      this.setState({ ...calculated });
    }
    return calculated;
  }

  componentWillUpdate(nextProps, nextState) {
    let itemSel =
      this.props.navItems[this.props.currentView] ||
      this.props.containedViews[this.props.currentView];
    let nextItemSel =
      nextProps.navItems[nextProps.currentView] || nextProps.containedViews[nextProps.currentView];
    if (this.props.canvasRatio !== nextProps.canvasRatio || itemSel !== nextItemSel) {
      let isCV = !isView(nextProps.currentView);
      window.canvasRatio = nextProps.canvasRatio;
      let calculated = this.aspectRatio(nextProps, nextState);
      this.setState({ fontBase: changeFontBase(calculated.width) });
    }
  }
}

VisorCanvasSli.propTypes = {
  /**
   * Show the current view
   */
  show: PropTypes.bool,
  /**
   * Object containing all created boxes (by id)
   */
  boxes: PropTypes.object.isRequired,
  /**
   * Slide aspect ratio
   */
  canvasRatio: PropTypes.number.isRequired,
  /**
   * Changes current view
   */
  changeCurrentView: PropTypes.func.isRequired,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /**
   * Current view
   */
  currentView: PropTypes.any,
  /**
   * Object containing all views (by id)
   */
  navItems: PropTypes.object.isRequired,
  /**
   * Function to delete last view
   */
  removeLastView: PropTypes.func.isRequired,
  /**
   * Rich plugin state during transition
   */
  richElementsState: PropTypes.object,
  /**
   * Show canvas (a navItem needs to be chosen)
   */
  showCanvas: PropTypes.bool,
  /**
   * Course title
   */
  title: PropTypes.any,
  /**
   *  Contains created views
   */
  viewsArray: PropTypes.array,
  /**
   * Whether the app is in SCORM mode or not
   */
  fromScorm: PropTypes.bool,
  /**
   * Object containing all the exercises in the course
   */
  exercises: PropTypes.object.isRequired,
  /**
   * Function for submitting a page Quiz
   */
  submitPage: PropTypes.func.isRequired,
  /**
   * Function for submitting a page Quiz
   */
  setAnswer: PropTypes.func.isRequired,
  tryAgainHandler: PropTypes.func.isRequired,
  seeAnswerHandler: PropTypes.func.isRequired,
  /**
   * Pages toolbars
   */
  viewToolbars: PropTypes.object,
  /**
   * All marks
   */
  marks: PropTypes.object,
  /**
   * Boxes toolbars
   */
  pluginToolbars: PropTypes.object,
  /**
   * Function that triggers a mark
   */
  onMarkClicked: PropTypes.func,
  /**
   * Indicates if the content is being previewed in order to export it to PDF
   */
  fromPDF: PropTypes.bool,
  /**
   * Indicates the expected width for PDF exportation.
   */
  expectedWidth: PropTypes.number,
};
